export function getUrlKeys (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

export function getRandom (min, max) {
  return min + parseInt(Math.random() * (max - min + 1))
}